import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "10.5",
    r: "2.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "3.5",
    cy: "10.5",
    r: "2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5 10 3H6m-.263 6.373L3.5 5H1m4.549 6.939L10.499 4"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7 2H6v2h3.3l.008.022L6.459 8.59 4.112 4H1v2h1.888L3.4 7.001a3.5 3.5 0 1 0 2.996 5.466h.002l3.778-6.058.42 1.154A3.5 3.5 0 1 0 12.518 7L10.7 2Zm-5.91 9.268-.03.049A1.499 1.499 0 0 1 2 10.5a1.5 1.5 0 1 1 2.789.768ZM12.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "currentColor"
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconBike16 = createIcon(IconComponent);